import { InvalidTransitionError } from '../errors.js';

export type ProspectStage =
  | 'lead'
  | 'contacted'
  | 'proposal_sent'
  | 'negotiation'
  | 'won'
  | 'lost';

export const TERMINAL_STAGES: readonly ProspectStage[] = ['won', 'lost'];

export const VALID_TRANSITIONS: Record<ProspectStage, readonly ProspectStage[]> = {
  lead: ['contacted', 'lost'],
  contacted: ['proposal_sent', 'lost'],
  proposal_sent: ['negotiation', 'won', 'lost'],
  negotiation: ['won', 'lost'],
  won: [],
  lost: [],
};

export function canTransitionStage(
  from: ProspectStage,
  to: ProspectStage,
): { ok: true } | { ok: false; reason: string } {
  if (from === to) {
    return { ok: false, reason: `already in stage "${from}"` };
  }
  if (TERMINAL_STAGES.includes(from)) {
    return { ok: false, reason: `"${from}" is terminal; no transitions permitted` };
  }
  if (!VALID_TRANSITIONS[from].includes(to)) {
    return { ok: false, reason: `"${from}" cannot advance to "${to}"` };
  }
  return { ok: true };
}

export function assertTransition(from: ProspectStage, to: ProspectStage): void {
  const result = canTransitionStage(from, to);
  if (!result.ok) {
    throw new InvalidTransitionError('prospect', from, to);
  }
}
